import { useState } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { SalesTab } from "@/components/AdminSales";
import { DiscountsTab } from "@/components/AdminDiscounts";

/**
 * FinancePage — single Finance tab merging Guide sales, Package sales, and
 * Discounts. Each is preserved as-is under a sub-tab so nothing changes for
 * the existing flows; only the nav container is new.
 */
export function FinancePage({ pw }) {
  const [sub, setSub] = useState("packages");
  return (
    <div className="space-y-6" data-testid="admin-finance">
      <div>
        <h2 className="font-display text-3xl font-extrabold text-[#0D2F4D]">Finance</h2>
        <p className="text-sm text-[#6F8FA8] mt-1">Everything on the money side — package purchases, guide micro-transactions, and the discount codes you're running.</p>
      </div>

      <Tabs value={sub} onValueChange={setSub}>
        <TabsList className="bg-[#F2F2EF] p-1.5 rounded-2xl h-auto">
          <TabsTrigger
            value="packages"
            data-testid="finance-tab-packages"
            className="data-[state=active]:bg-[#0D2F4D] data-[state=active]:text-[#C6D21F] text-[#0D2F4D] font-semibold text-xs px-4 py-2 rounded-xl"
          >Package sales</TabsTrigger>
          <TabsTrigger
            value="guides"
            data-testid="finance-tab-guides"
            className="data-[state=active]:bg-[#0D2F4D] data-[state=active]:text-[#C6D21F] text-[#0D2F4D] font-semibold text-xs px-4 py-2 rounded-xl"
          >Guide sales</TabsTrigger>
          <TabsTrigger
            value="discounts"
            data-testid="finance-tab-discounts"
            className="data-[state=active]:bg-[#0D2F4D] data-[state=active]:text-[#C6D21F] text-[#0D2F4D] font-semibold text-xs px-4 py-2 rounded-xl"
          >Discounts</TabsTrigger>
        </TabsList>

        <TabsContent value="packages" className="mt-6"><SalesTab pw={pw} type="packages"/></TabsContent>
        <TabsContent value="guides"   className="mt-6"><SalesTab pw={pw} type="guides"/></TabsContent>
        <TabsContent value="discounts" className="mt-6"><DiscountsTab pw={pw}/></TabsContent>
      </Tabs>
    </div>
  );
}
